<template>
  <new-layout
    :backgroundImage="backgroundImage"
    :backgroundImage2x="backgroundImage2x"
    :showLogo="false"
    no-center-align
  >
    <div :class="currentStep + 'Height'">
        <login-card
          v-show="currentStep === 'login'"
          @successLogin="changeStep('accessMethod')"
        />
        <access-method-card
          v-if="currentStep === 'accessMethod'"
          @backLogin="backToLogin"
          @successToken="changeStep('tokenSent')"
        />
        <token-sent-card
          v-if="currentStep === 'tokenSent'"
          @backLogin="backToLogin"
        />
    </div>
  </new-layout>
</template>

<script>

import AccessMethodCard from '@/feature/login/components/AccessMethodCard.vue';
import TokenSentCard from '@/feature/login/components/TokenSentCard.vue';
import LoginCard from '@/feature/login/components/LoginCard.vue';
import NewLayout from '@/feature/login/components/NewLayout.vue';

export default {
  metaInfo: {
    title: 'Login',
  },
  components: {
    NewLayout,
    LoginCard,
    AccessMethodCard,
    TokenSentCard,
  },
  data() {
    return {
      backgroundImage: 'https://cdn.parcelex.com.br/assets/v3/persons/woman-with-bags-big.png',
      backgroundImage2x: 'https://cdn.parcelex.com.br/assets/v3/persons/woman-with-bags-big@2x.png',
      currentStep: 'login',
    };
  },
  methods: {
    changeStep(step) {
      this.currentStep = step;
    },
    backToLogin() {
      this.changeStep('login');
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .loginHeight, .accessMethodHeight, .tokenSentHeight {
    display: flex;

    @media (max-width: 1000px) {
      justify-content: center;
      padding-left: 0;
    }
  }

  .loginHeight {
    max-height: 25.25rem;
    transition: all 0.3s;
  }

  .accessMethodHeight {
    max-height: 26.875rem;
    transition: all 0.3s;

    @media (max-width: $sm) {
      max-height: 530px;
    }
  }

  .tokenSentHeight {
    max-height: 21.875rem;
    transition: all 0.3s;
    @media (max-width: $sm) {
      max-height: 530px;
    }
  }

</style>
